module.exports = __webpack_public_path__ + "img/branche_logo.6b43b23e.jpg";